// extracted by mini-css-extract-plugin
module.exports = {"ArchiveComponent":"Analysis_ArchiveComponent__35iUS","title":"Analysis_title__375Aa"};